import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {
   AfterViewChecked,
   ChangeDetectorRef,
   Component,
   DoCheck,
   EventEmitter,
   Inject,
   Input,
   OnInit,
   Output,
   ViewChild,
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {CountryISO, PhoneNumberFormat, SearchCountryField} from 'ngx-intl-tel-input';
import {AddressFormComponent} from 'src/app/shared/components/address-form/address-form.component';
import {ProfilesEnum} from 'src/app/shared/enums';
import {
   AuthModel,
   ContextModel,
   Country,
   OrderDetails,
   Region,
   SavedAddress,
   ShippingAddress,
} from 'src/app/shared/models';
import {AddressModel} from 'src/app/shared/models/address.model';
import {AddressService, LocationService} from 'src/app/shared/services';
import {AccountLinkGeneratorService} from 'src/app/shared/services/account-link-generator.service';
import {UserService} from 'src/app/shared/services/user.service';
import {
   emailShippingValidator,
   specialApartmentCaracterValidator,
   specialBlockCaracterValidator,
   specialStreetCaracterValidator,
} from 'src/app/shared/validators/email.validator';
import {provinceCodeValidator} from 'src/app/shared/validators/provinceCode.validator';
import {SelectableAddressField} from '../../../shared/models/selectable-address-field.model';
import {ShippingService} from '../shipping.service';

@Component({
   selector: 'app-shipping-address',
   templateUrl: './shipping-address.component.html',
   styleUrls: ['./shipping-address.component.scss'],
})
export class ShippingAddressComponent implements OnInit, DoCheck, AfterViewChecked {
   constructor(
      @Inject(DOCUMENT) private document: Document,
      public fb: FormBuilder,
      public http: HttpClient,
      public locationService: LocationService,
      private userService: UserService,
      private addressService: AddressService,
      private route: ActivatedRoute,
      private accountLinkGenerator: AccountLinkGeneratorService,
      private shippingService: ShippingService,
      private cdr: ChangeDetectorRef
   ) {}

   @ViewChild(AddressFormComponent) addressComponent: AddressFormComponent;
   @Output() formValueEmitter = new EventEmitter();
   @Output() editModeEmitter = new EventEmitter();
   addressForm: FormGroup;
   contactForm: FormGroup;
   translatePath = 'public.shipping-details.';
   countries!: Array<Country>;
   regions!: Array<Region>;
   sel = '';
   defaultCountry: Country;
   private readonly contextKey = 'selectedContext';
   private readonly sessionStorageAddressKey = 'mdeliverysavedorderaddress';
   currentContext: ContextModel | null;
   addresses: SavedAddress[];
   expanded = true;
   editModeOn = true;
   doSaveAddress = true;
   selectedAddress: SavedAddress | null;
   profilesEnum = ProfilesEnum;
   loading = false;
   user: AuthModel;
   shippingAddress: ShippingAddress;
   sessionSavedData: {serviceId: string; orderId: string; address: ShippingAddress; contacts: ShippingAddress};
   params: ParamMap;
   interShippment: boolean;
   valueBar = 50;
   valueChecking = false;
   checkShippment = false;
   cssPhoneValidate = 'form-control is-valid';
   @Output() internationalShippment = new EventEmitter();
   @Input() orderDetails: OrderDetails = new OrderDetails();

   separateDialCode = true;
   SearchCountryField = SearchCountryField;
   CountryISO = CountryISO;
   PhoneNumberFormat = PhoneNumberFormat;
   preferredCountries: CountryISO[] = [CountryISO.Moldova, CountryISO.Romania];

   addressFormHandle = false;
   addressValidatorHandle = false;
   contactFormHandle = false;
   submitPage = false;

   ngOnInit(): void {
      window.location.href.includes('shipping?') ? (this.submitPage = true) : (this.submitPage = false);
      this.handleFormStatus();

      sessionStorage.setItem('check', 'false');
      const disableFirstname = true;
      this.params = this.route.snapshot.queryParamMap;
      this.initForm();
      this.userService.isAutenticated$.subscribe((response) => {
         if (response && response.isAuthenticated && !this.sessionSavedData) {
            this.contactForm.patchValue({
               email:
                  response.user.emailAddress == null || response.user.emailAddress == undefined
                     ? ''
                     : response.user.emailAddress,
               phone: response.user.mobilePhone,
               firstName: response.user.firstName,
               lastName: response.user.lastName,
            });
            this.user = response;
         } else {
            this.contactForm.patchValue({
               email:
                  this.orderDetails?.receiver?.email == null || this.orderDetails?.receiver?.email == undefined
                     ? ''
                     : this.orderDetails?.receiver?.email,
               phone: this.orderDetails?.receiver?.phone,
               firstName: this.orderDetails?.receiver?.name,
               lastName: this.orderDetails?.receiver?.firstName,
            });
         }
         if (this.contactForm.get('firstName')?.value) {
            this.contactForm.get('firstName')?.disable();
         }
         if (this.contactForm.get('lastName')?.value) {
            this.contactForm.get('lastName')?.disable();
         }
      });
   }

   setEditModeState(state: boolean): void {
      console.log('setEditModeState', state);
      this.editModeOn = state;
      this.editModeEmitter.emit(state);
   }

   patchSessionSavedData(): void {
      this.sessionSavedData = sessionStorage.getItem(this.sessionStorageAddressKey)
         ? JSON.parse(sessionStorage.getItem(this.sessionStorageAddressKey)!)
         : null;
      const orderId = this.params.has('orderId') ? this.params.get('orderId') : null;
      const serviceId = this.params.has('serviceId') ? this.params.get('serviceId') : null;
      const returnUrl = this.params.has('returUrl') ? this.params.get('returUrl') : null;

      if (this.sessionSavedData && orderId && serviceId) {
         if (this.sessionSavedData.orderId == orderId && this.sessionSavedData.serviceId == serviceId) {
            // this.addressForm.patchValue(this.sessionSavedData.address);
            this.contactForm.patchValue(this.sessionSavedData.contacts);
            this.confirmAddress(true);
         }
      }
   }

   // getSavedAddresses() {
   //    this.addressService.getList().subscribe((res) => {
   //       this.addresses = res;
   //       const defaultAddress = this.addresses.find((element) => element.isDefault == true);
   //       if (defaultAddress && this.sessionSavedData == null) {
   //          this.existingAddressSelected(defaultAddress);
   //       }
   //    });
   // }

   useNewAddress() {
      const country = this.addressForm.get('country')?.value;
      this.doSaveAddress = true;
      this.selectedAddress = null;
      this.addressForm.reset();
      this.addressForm.get('country')?.setValue(country);
      this.shippingService.setAddressValidator(false);
   }

   // existingAddressSelected(item: SavedAddress): void {
   //    sessionStorage.setItem('infoCountry', 'true');
   //    const international = item.internationalAddress;
   //    this.doSaveAddress = false;
   //    this.selectedAddress = item;
   //    item.address
   //       ? this.addressForm.patchValue(item.address)
   //       : this.addressForm.patchValue({
   //            apartment: international.apartment,
   //            block: international.block,
   //            city: international.city,
   //            country: international.country,
   //            region: international.region,
   //            provinceCode: international.provinceCode,
   //            street: international.street,
   //            zipCode: international.zipCode,
   //            isLocal: 'false',
   //         });
   //    this.addressForm.markAllAsTouched();
   //    this.addressForm.updateValueAndValidity();
   // }

   getShippingInternationalAddressText(item: any): string {
      const address = item;
      return `
    ${address.street ? address.street + ', ' : ''}
    ${address.block ? address.block + ', ' : ''}
    ${address.apartment ? address.apartment + ', ' : ''}
    ${address.zipCode ? address.zipCode + ', ' : ''}
    ${address.city ? address.city + ', ' : ''}
    ${address.region ? address.region + ', ' : ''}
    ${address.provinceCode ? address.provinceCode + ', ' : ''}
    ${address.country ? address.country : ''}
    `;
   }

   getShippingAddressText(item: any): string {
      const address = item;
      return `
    ${address.street.value ? address.street.value + ', ' : ''}
    ${address.block ? address.block + ', ' : ''}
    ${address.apartment ? address.apartment + ', ' : ''}
    ${address.zipCode ? address.zipCode + ', ' : ''}
    ${address.city.value ? address.city.value + ', ' : ''}
    ${address.region.value ? address.region.value + ', ' : ''}
    ${address.country.value ? address.country.value : ''}
    `;
   }

   changePreferredCountries() {
      this.preferredCountries = [CountryISO.Canada];
   }

   initForm(): void {
      this.contactForm = this.fb.group({
         email: ['', [emailShippingValidator]],
         phone: [this.orderDetails?.receiver?.phone, [Validators.required]],
         firstName: [null, [Validators.required]],
         lastName: [null, [Validators.required]],
      });
      if (this.checkShippment) {
         this.addressForm = this.fb.group({
            country: ['', [Validators.required]],
            region: [null, [Validators.required]],
            provinceCode: ['', [provinceCodeValidator.cannotContainSpace]],
            city: ['', [Validators.required]],
            street: ['', [specialStreetCaracterValidator]],
            block: ['', [Validators.required, specialBlockCaracterValidator]],
            apartment: ['', [specialApartmentCaracterValidator]],
            zipCode: ['', [Validators.required]],
         });
      } else {
         this.addressForm = this.fb.group({
            country: ['', [Validators.required]],
            region: [null, [Validators.required]],
            city: ['', [Validators.required]],
            street: ['', [specialStreetCaracterValidator]],
            block: ['', [specialBlockCaracterValidator]],
            apartment: ['', [specialApartmentCaracterValidator]],
            zipCode: ['', [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
         });
      }
   }

   public confirmAddress(auto = false) {
      this.addressForm.markAllAsTouched();
      this.addressForm.updateValueAndValidity();
      this.contactForm.markAllAsTouched();
      this.contactForm.updateValueAndValidity();

      if (this.addressForm.get('street')?.value == null) {
         this.addressForm.get('street')?.setValue(' ');
      }

      if (this.contactForm.valid && this.addressForm.valid) {
         const contacts = this.contactForm.getRawValue() as ShippingAddress;
         const address = this.addressForm.getRawValue() as ShippingAddress;

         // if (address.country && typeof address.country === 'object') {
         //    const countryValue = address.country;
         //    address.country = {value: countryValue};
         // }

         address.region = address.region as SelectableAddressField;
         address.provinceCode = address.provinceCode ?? '';
         address.city = address.city as SelectableAddressField;
         address.street = address.street as SelectableAddressField;
         address.block = address.block ?? '';
         address.apartment = address.apartment ?? '';
         address.zipCode = address.zipCode.includes('MD-') ? address.zipCode.replace('MD-', '') : address.zipCode;
         this.saveAddressToLocal(contacts, address);
         this.shippingAddress = {...address, ...contacts} as ShippingAddress;
         this.shippingAddress.countryCode = this.shippingAddress.phone?.countryCode;
         this.shippingAddress.phone = this.shippingAddress.phone?.internationalNumber;
         if (this.shippingAddress.street === undefined || this.shippingAddress.street === null) {
            this.shippingAddress.street = new SelectableAddressField();
         }

         this.formValueEmitter.emit({
            shippingAddress: this.shippingAddress,
            autoConfirm: auto,
            isLocal: !this.checkShippment,
         });
      }
   }

   cssPhoneValidator() {
      return this.contactForm.get('phone')?.invalid && this.contactForm.get('phone')?.touched
         ? 'form-control is-invalid'
         : 'valid-phone form-control';
   }

   saveAddressToLocal(contacts: any, address: any) {
      const orderId = this.params.has('orderId') ? this.params.get('orderId') : null;
      const serviceId = this.params.has('serviceId') ? this.params.get('serviceId') : null;
      let object = {
         contacts,
         address,
      };
      if (orderId && serviceId) {
         object = {...object, ...{serviceId, orderId}};
      }
      sessionStorage.setItem(this.sessionStorageAddressKey, JSON.stringify(object));
   }

   saveNewAddress() {
      if (this.user && this.doSaveAddress) {
         this.addressService
            .saveAddress({address: this.addressForm.getRawValue() as AddressModel} as SavedAddress)
            .subscribe();
      }
   }

   login(): void {
      this.accountLinkGenerator.getLoginUrl(location.href).subscribe((res) => {
         this.document.body.innerHTML = res;
         this.document.forms[0].submit();
      });
   }

   getShippment(el: any): void {
      this.checkShippment = el;
      if (this.checkShippment) {
         this.addressForm = this.fb.group({
            country: ['', [Validators.required]],
            region: [null, [Validators.required]],
            provinceCode: ['', [provinceCodeValidator.cannotContainSpace]],
            city: ['', [Validators.required]],
            street: ['', [Validators.required, specialStreetCaracterValidator]],
            block: ['', [Validators.required, specialBlockCaracterValidator]],
            apartment: ['', [specialApartmentCaracterValidator]],
            zipCode: ['', [Validators.required]],
         });
      } else {
         this.addressForm = this.fb.group({
            country: ['', [Validators.required]],
            region: [null, [Validators.required]],
            city: ['', [Validators.required]],
            street: ['', [specialStreetCaracterValidator]],
            block: ['', [specialBlockCaracterValidator]],
            apartment: ['', [specialApartmentCaracterValidator]],
            zipCode: ['', [Validators.required]],
         });
      }

      this.internationalShippment.emit(!this.checkShippment);
      sessionStorage.setItem('check', String(!this.checkShippment));
   }

   validateStreet(): void {
      const block = this.addressForm.get('block')?.value;
      const street = this.addressForm.get('street')?.value;

      const firstCaseValidator = street === null && street?.length === undefined;
      const thirdCaseValidator = street?.length === 0 && street !== null;

      const blockCase = block?.length !== null && block?.length > 0;

      if ((blockCase && firstCaseValidator) || (blockCase && thirdCaseValidator)) {
         this.shippingService.setAddressValidator(true);
      } else {
         this.shippingService.setAddressValidator(false);
      }

      if (!this.editModeOn) {
         this.shippingService.setAddressValidator(false);
      }
   }

   ngDoCheck(): void {
      var errors: any = {};
      // Object.keys(this.addressForm.controls).forEach((key) => {
      //    if (this.addressForm.get(key)?.invalid) {
      //       errors[key] = {
      //          invalid: this.addressForm.get(key)?.errors,
      //          value: this.addressForm.get(key)?.value,
      //       };
      //    }
      // });
      // console.log(errors);

      if (this.addressForm.touched) {
         const apartment = this.addressForm.get(['apartment']);
         const block = this.addressForm.get(['block']);
         const city = this.addressForm.get(['city']);
         const country = this.addressForm.get(['country']);
         const region = this.addressForm.get(['region']);
         const street = this.addressForm.get(['street']);
         const provinceCode = this.addressForm.get(['provinceCode']);
         const zipCode = this.addressForm.get(['zipCode']);

         if (apartment?.touched && apartment.invalid) {
            this.shippingService.setAddressStatus(apartment.invalid);
         } else if (block?.touched && block.invalid) {
            this.shippingService.setAddressStatus(block.invalid);
         } else if (city?.touched && city.invalid) {
            this.shippingService.setAddressStatus(city.invalid);
         } else if (country?.touched && country.invalid) {
            this.shippingService.setAddressStatus(country.invalid);
         } else if (region?.touched && region.invalid) {
            this.shippingService.setAddressStatus(region.invalid);
         } else if (street?.touched && street.invalid) {
            this.shippingService.setAddressStatus(street.invalid);
         } else if (zipCode?.touched && zipCode.invalid) {
            this.shippingService.setAddressStatus(zipCode.invalid);
         } else if (provinceCode?.touched && provinceCode.invalid) {
            this.shippingService.setAddressStatus(provinceCode.invalid);
         } else {
            this.shippingService.setAddressStatus(false);
         }

         if (apartment?.touched || block?.touched) {
            this.validateStreet();
         }

         if (this.contactForm.touched) {
            const email = this.contactForm.get(['email']);
            const firstName = this.contactForm.get(['firstName']);
            const lastName = this.contactForm.get(['lastName']);
            const phone = this.contactForm.get('phone')?.value?.e164Number;

            if (email?.touched && email.invalid) {
               this.shippingService.setContactStatus(email.invalid);
            } else if (firstName?.touched && firstName.invalid) {
               this.shippingService.setContactStatus(firstName.invalid);
            } else if (lastName?.touched && lastName.invalid) {
               this.shippingService.setContactStatus(lastName.invalid);
            } else if (phone?.touched && phone.invalid) {
               this.shippingService.setContactStatus(phone.invalid);
            } else {
               this.shippingService.setContactStatus(false);
            }
         }
      }
   }

   handleFormStatus(): void {
      this.shippingService.addressFormStatus.subscribe((status) => {
         status === true ? (this.addressFormHandle = true) : status === false ? (this.addressFormHandle = false) : '';
      });

      this.shippingService.contactFormStatus.subscribe((status) => {
         status === true ? (this.contactFormHandle = true) : status === false ? (this.contactFormHandle = false) : '';
      });

      this.shippingService.addressValidatorStatus.subscribe((status) => {
         this.addressValidatorHandle = status;
      });
   }

   ngAfterViewChecked(): void {
      this.cdr.detectChanges();
   }
}
